// ===========================================
// Subscriptions Page
// ===========================================
// Admin page for managing family subscriptions

import { Box } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import SubscriptionsTab from '../../components/admin/pricing/SubscriptionsTab';

// ===========================================
// MAIN COMPONENT
// ===========================================

export default function SubscriptionsPage() {
  return (
    <Box>
      <PageHeader
        title="Subscriptions"
        subtitle="View and manage family subscriptions"
        breadcrumbs={[
          { label: 'Admin', path: '/admin' },
          { label: 'Subscriptions' },
        ]}
      />

      <SubscriptionsTab />
    </Box>
  );
}
